import React, { useState } from "react";

import Popup from "../../atoms/Popup/Popup";
import Textarea from "../../atoms/TextArea/Textarea";
import Button from "../../atoms/Button/Button";

import "./RequestToUpload.styles.scss";

interface ModalProps {
  show: boolean;
  onConfirmation: (action: boolean, text?: string) => void;
  onClose: () => void;
}

const RequestToUpload: React.FC<ModalProps> = ({
  show,
  onConfirmation,
  onClose,
}) => {
  const [formFields, setFormFields] = useState({
    reason: "",
  });
  const [errors, setErrors] = useState({
    reason: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    const newErrors = { ...errors };

    switch (fieldName) {
      case "reason":
        if (!fieldValue) {
          newErrors.reason = "Reason is required";
        } else if (fieldValue.length < 3) {
          newErrors.reason = "Minimum 3 characters are required";
        } else {
          newErrors.reason = "";
        }
        break;
    }
    setFormFields({
      ...formFields,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...newErrors });
  };

  const handleValidate = () => {
    if (!formFields.reason) {
      setErrors({ ...errors, reason: "Reason is required" });
      return;
    } else if (formFields.reason.length < 3) {
      setErrors({ ...errors, reason: "Minimum 3 characters are required" });
      return;
    } else {
      setErrors({ ...errors, reason: "" });
      onConfirmation(true, formFields.reason);
    }
  };

  if (!show) return null;

  return (
    <Popup show={show} onClose={onClose} headerText="Request to Upload">
      <div className="request-to-upload-container">
        <p className="request-to-upload-title">
          Write a reason to reject this document?
        </p>
        <Textarea
          label="Reason"
          name="reason"
          onChange={handleChange}
          value={formFields.reason}
          placeholder="Enter your text here..."
          error={!!errors.reason}
          helperText={errors.reason}
        />
        <div className="popup-footer">
          <Button variant="outlined" onClick={() => onConfirmation(false)}>
            Cancel
          </Button>
          <Button onClick={handleValidate}>Submit</Button>
        </div>
      </div>
    </Popup>
  );
};

export default RequestToUpload;
